import React, { useEffect, useState } from 'react';
import { NotificationManager } from 'react-notifications';
import AutorizacoesService from 'services/AutorizacoesService';
import { useQuery } from 'store/useQuery';
import { AccessWrapper, ButtonsWrapper, InputWrapper } from './style';
import Lottie from 'react-lottie';
import LockLottie from '../../../../assets/images/lottie/lock.json';
import { Button } from '../Acceptance/style';
import { DefaultMessagesNotification } from 'constants/notificationMessage';

function AccessControl({ setCanAccess }){
    const [pinValue, setPinValue] = useState('');
    const [validating, setValidating] = useState(false);
    const [correctPin, setCorrectPin] = useState(false);
    const [invalidPin, setInvalidPin] = useState(false);
    const [loading, setLoading] = useState(false);
    const { queryParams } = useQuery();

    useEffect(() => {
        EnviarCodigoAutorizacao();
    }, [queryParams]);

    const EnviarCodigoAutorizacao = async () => {
        if(!queryParams.cotacao) return
        if(loading){
            NotificationManager.warning("Aguarde enquanto o novo código é enviado.")
            return false;
        }
        setInvalidPin(false);
        setPinValue('')
        setLoading(true)
        return await AutorizacoesService.EnviarCodigoAutorizacaoCotacao(queryParams.cotacao)
        .then(response => {
            NotificationManager.success("Um código de verificação foi enviado para o seu email.","Código enviado.")
            setLoading(false)
            return true;
        })
        .catch(error => {
            setLoading(false)
            var errorMessage = error.response?.data?.erros[0] ?? DefaultMessagesNotification.ErrorBodyGeneric
            NotificationManager.error(errorMessage, 'Não foi possível solicitar um novo código!', 7000);
            return false;
        });
    }

    const HandleReenviarCodigo = async () =>{
        await EnviarCodigoAutorizacao();
    }
    function handlePinChange(event){
        setCorrectPin(false);
        setInvalidPin(false);
        const { value } = event.target;
        const numberRegex = /^[0-9\b]{0,6}$/;
        if(numberRegex.test(value)){
          setPinValue(value)
        }
      }
    const options = {
        loop: false,
        autoplay: false,
        animationData: LockLottie,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    }
    async function handleFormSubmit(event) {
        event.preventDefault();
    
        setInvalidPin(false);
        setValidating(true);
        await AutorizacoesService.ValidarCodigoAutorizacaoCotacao(queryParams.cotacao, pinValue)
            .then(response => {
                setCorrectPin(true);
                setValidating(false);
                setCanAccess(true);
            })
            .catch(error => {
                setInvalidPin(true);
                setValidating(false);
                var errorMessage = error.response?.data?.erros[0] ?? DefaultMessagesNotification.ErrorBodyGeneric
                NotificationManager.error(errorMessage, 'Ocorreu um erro!', 5000);
                return 
            });
    }
    return(
        <AccessWrapper onSubmit={(event) => handleFormSubmit(event)}>
            <div>
                <Lottie options={options} width={96} height={96} isStopped={!correctPin} />

                <h4>Código de segurança</h4>
                <p>Para acessar a página, insira o código de segurança de 6 digitos que foi enviado para o seu e-mail.</p>

                <InputWrapper>
                    <input type="text" name="pinValue" maxLength="6" minLength="6" title="Somente números são permitidos"
                        disabled={!!validating} required={true} value={pinValue} onChange={(event)=> handlePinChange(event)}
                    />
                </InputWrapper>

                { !!invalidPin && <span>Código incorreto!</span> }

                {
                    !correctPin && (
                        <ButtonsWrapper>
                            { 
                                !!(validating || loading) ? (
                                    <div className="block-loading">
                                    <div className="simple-loading"></div>
                                    </div>
                                ) : (
                                    <React.Fragment>
                                        <Button 
                                            htmlType="button" 
                                            buttonType="back" 
                                            disabled={!!(validating || loading)}
                                            onClick={() => HandleReenviarCodigo()}>Reenviar código
                                        </Button>
                                        <Button 
                                            htmlType="submit" 
                                            buttonType="accept" 
                                            disabled={!!(validating || loading)}>Verificar código
                                        </Button>
                                    </React.Fragment>
                                )
                            }
                        </ButtonsWrapper>
                    )
                }
            </div>
        </AccessWrapper>
    )
}

export default AccessControl